export class SonyVplProjector {
    constructor(socket, log) {
        this.socket = socket;
        this.displayBlank = false;
        this.displayFreeze = false;
        this.input = 'hdmi1'; // hdmi 1
        this.power = false;
        this.firmwareVersion = '[{"main":"1.00.0a"}, {"main_data":"01/01.01"}, {"sub":"1.01.0a"}, {"ext":"1.03.0a")]';
        this.serialNumber = '12345678';
        // Support inputs for all models.
        this.validVideoInputs = ['video1', 'dvi1', 'svideo1', 'rgb1', 'hdmi1', 'hdbaset1'];
        this.asyncHandlers = [
            {
                name: 'displayBlank',
                regExp: /blank (\?|"on"|"off")/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1] === '?')
                            this.socket.send(this.displayBlank ? '"on"' : '"off"');
                        else {
                            this.displayBlank = match[1].localeCompare('"on"') === 0 ? true : false;
                            this.socket.send(`ok`);
                        }
                    }
                },
            },
            {
                name: 'displayFreeze',
                regExp: /freeze (\?|"on"|"off")"/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1] === '?')
                            this.socket.send(this.displayFreeze ? '"on"' : '"off"');
                        else {
                            this.displayFreeze = match[1].localeCompare('"on"') === 0 ? true : false;
                            this.socket.send(`ok`);
                        }
                    }
                },
            },
            {
                name: 'firmwareVersionGet',
                regExp: /version \?/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(`${this.firmwareVersion}`);
                    }
                },
            },
            {
                name: 'input',
                regExp: /input (\?|".+")/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1] === '?')
                            this.socket.send(`"${this.input}"`);
                        else {
                            this.input = match[1];
                            const result = this.validVideoInputs.includes(this.input) ? 'ok' : 'err';
                            this.socket.send(result);
                        }
                    }
                },
            },
            {
                name: 'power',
                regExp: /power ("on"|"off")/i,
                callback: (match) => {
                    this.power = match[1].localeCompare('"on"') === 0 ? true : false;
                    this.socket.send(`ok`);
                },
            },
            {
                name: 'power_status',
                regExp: /power_status \?/i,
                callback: (match) => {
                    this.socket.send(this.power ? '"on"' : '"standby"');
                },
            },
            {
                name: 'serialNumberGet',
                regExp: /serial \?/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(this.serialNumber);
                    }
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.input === code)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.input = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '1';
    }
}
SonyVplProjector.emulatorType = 'socketEmulator';
SonyVplProjector.key = '-Need one';
